import React from 'react';
import BsModal from './BsModal';

const SuccessDialog = ({ show, message, details, onClose }) => {
  if (!show) return null;

  return (
<BsModal
      show={show}
      onClose={onClose}
      title=""
      >

<div className="modal-body text-center p-5">
            <div className="mb-4">
              <div
                className="rounded-circle mx-auto mb-3 d-flex justify-content-center align-items-center"
                style={{
                  width: 80,
                  height: 80,
                  backgroundColor: '#E6F4EA',
                  border: '3px solid #34D399'
                }}
              >
                <i className="fa fa-check text-success" style={{ fontSize: 36 }}></i>
              </div>
              <h5 className="font-weight-bold mb-2">{message || 'Success!'}</h5>
              {details && (
                <p className="text-muted">
                  {typeof details === 'object' ? JSON.stringify(details) : details}
                </p>
              )}
            </div>
            <button className="btn btn-primary px-4" onClick={onClose}>
              OK
            </button>
          </div>


      </BsModal>
  );
};

export default SuccessDialog;
